import set from 'lodash/fp/set';
import get from 'lodash/get';
import omit from 'lodash/omit';
import reduce from 'lodash/reduce';

import {
  ADD_PAIRED_MEALS_V3,
  REMOVE_PAIRED_MEAL_V3,
  CLEAR_EDITED_BASKET_V3,
  UNDO_BASKET_EDITS_V3,
  SET_EDITED_BASKET_V3,
} from 'lib/constants/v3Actions';

const initialState = {};

export default (state = initialState, action) => {
  switch (action.type) {
    case ADD_PAIRED_MEALS_V3:
      return set(action.hostMealId, action.pairedMealId, state);
    case REMOVE_PAIRED_MEAL_V3:
      return omit(state, action.hostMealId);
    case UNDO_BASKET_EDITS_V3:
    case SET_EDITED_BASKET_V3:
      return reduce(
        action.selectedPairings,
        (hash, pair) => ({ ...hash, [pair.hostMealId]: pair.suggestedPairing.id }),
        {}
      );
    case CLEAR_EDITED_BASKET_V3:
      return initialState;
    default:
      return state;
  }
};

export const selectPairingForHostMeal = (state, mealId) => get(state, mealId);
